import * as tslib_1 from "tslib";
var CODE = 'SoftwareTokenMfaRequired';
var SoftwareTokenMfaRequiredError = /** @class */ (function (_super) {
    tslib_1.__extends(SoftwareTokenMfaRequiredError, _super);
    function SoftwareTokenMfaRequiredError() {
        var _this = _super.call(this, CODE) || this;
        _this['error'] = { code: CODE };
        return _this;
    }
    return SoftwareTokenMfaRequiredError;
}(Error));
export { SoftwareTokenMfaRequiredError };
